import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';

const API_HOST = process.env.REACT_APP_API_HOST;

export interface AnalyticsReport {
  // Додайте типи для звітів аналітики
  [key: string]: any;
}

export interface AnalyticsUsers {
  // Додайте типи для користувачів аналітики
  [key: string]: any;
}

export const analyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info?.api_token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Analytics'],
  endpoints: (build) => ({
    getAnalyticsReport: build.query<AnalyticsReport, { startDate?: string; endDate?: string; type?: string }>({
      query: (params) => {
        const query = new URLSearchParams();
        if (params.startDate) query.append('startDate', params.startDate);
        if (params.endDate) query.append('endDate', params.endDate);
        if (params.type) query.append('type', params.type);
        
        return {
          url: `analytics/report?${query.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Analytics'],
    }),
    
    getAnalyticsUsers: build.query<AnalyticsUsers, void>({
      query: () => ({
        url: 'analytics/users',
        method: 'GET',
      }),
      providesTags: ['Analytics'],
    }),
    
    getUserListForAnalytics: build.query<any[], void>({
      query: () => ({
        url: 'user/list?limit=99999',
        method: 'GET',
      }),
      providesTags: ['Analytics'],
    }),
  }),
});

export const {
  useGetAnalyticsReportQuery,
  useGetAnalyticsUsersQuery,
  useGetUserListForAnalyticsQuery,
} = analyticsApi; 